// extracted by mini-css-extract-plugin
export var button = "home-survey-section-module--button--I4F6v";
export var content = "home-survey-section-module--content--4SUE6";
export var contentWrapper = "home-survey-section-module--content-wrapper--c+6zO";
export var main = "home-survey-section-module--main--lsJiL";
export var topPadding = "home-survey-section-module--top-padding--coNdz";